import Mutations from '../../odata/mutations';

export default { ...new Mutations('automatedResponse'), ...new Mutations('automatedResponses') };
